import request from '@/plugin/axios'

export function page(query) {
return request({
url: '/api/admin/material/page',
method: 'get',
params: query
})
}

export function findMaterialAll(obj) {
return request({
url: '/api/admin/material/findMaterialAll',
method: 'post',
data: obj
})
}
export function findMaterialList(obj) {
return request({
url: '/api/admin/material/findMaterialList',
method: 'get'
})
}

export function addObj(obj) {
return request({
url: '/api/admin/material',
method: 'post',
data: obj
})
}

export function getObj(id) {
return request({
url: '/api/admin/material/' + id,
method: 'get'
})
}

export function delObj(id) {
return request({
url: '/api/admin/material/' + id,
method: 'delete'
})
}

export function putObj(id, obj) {
return request({
url: '/api/admin/material/' + id,
method: 'put',
data: obj
})
}
